<div *ngIf="current" class="message tenant-action-banner" [class.tenant-action-banner--error]="current.severity === 'ERROR'">
	<div class="tenant-action-banner__content">
		<mat-icon class="mat-error-icon">{{ iconName() }}</mat-icon>
		<div class="tenant-action-banner__text">
			{{ translationKey() | translate }}
			<a [routerLink]="deepLinkPath" [queryParams]="deepLinkQueryParams">{{ 'TENANT_ACTIONS.cta' | translate }}</a>
		</div>
		<button
			*ngIf="current.severity !== 'ERROR'"
			mat-icon-button
			class="tenant-action-banner__dismiss"
			(click)="dismiss()"
			[attr.aria-label]="'TENANT_ACTIONS.dismiss' | translate"
		>
			<mat-icon>close</mat-icon>
		</button>
		<mat-icon *ngIf="current.severity === 'ERROR'" class="mat-error-icon">{{ iconName() }}</mat-icon>
	</div>
</div>
